import { createCollectionReducer } from 'reducers/account/collections';

import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectUserQualifiedContent = (state, userId) =>
  state.account.userQualifiedContent?.[userId];
